import { createContext, useState, useCallback, useMemo, useEffect } from "react";
import PropTypes from "prop-types";

import { STORAGE_SHARE_LINK_KEY, STORAGE_EMAIL_KEY } from "modules/help-a-friend/consts";
import { useReferralProgramConfig } from "contexts/DataContext/hooks";
import { updateStorageItem } from "./utils";

export const UserContext = createContext({});

export const UserContextProvider = ({ children }) => {
  const [userEmail, setUserEmail] = useState("");
  const [shareLink, setShareLink] = useState("");

  const referralProgramConfig = useReferralProgramConfig();
  const { campaignSource } = referralProgramConfig;

  const fullStorageEmailKey = `${campaignSource}:${STORAGE_EMAIL_KEY}`;
  const fullStorageLinkKey = `${campaignSource}:${STORAGE_SHARE_LINK_KEY}`;

  useEffect(() => {
    const email = localStorage.getItem(fullStorageEmailKey) || "";
    const link = localStorage.getItem(fullStorageLinkKey) || "";

    setUserEmail(email);
    setShareLink(link);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateShareLink = useCallback((link) => {
    updateStorageItem(fullStorageLinkKey, link);
    setShareLink(link);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateEmail = useCallback((email) => {
    updateStorageItem(fullStorageEmailKey, email);
    setUserEmail(email);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const value = useMemo(
    () => ({
      updateShareLink,
      updateEmail,
      userEmail,
      shareLink,
      setUserEmail,
    }),
    [updateShareLink, updateEmail, userEmail, shareLink, setUserEmail]
  );

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

UserContextProvider.propTypes = {
  children: PropTypes.node,
};

UserContextProvider.defaultProps = {
  children: null,
};
